<template>
  <div>
    <b-card>
      <b-card-body>
        <b-card-text>Payment Methods</b-card-text>
        <b-list-group-item
          v-for="p in payMethods"
          :key="p.id"
          class="d-flex align-items-center"
        >
          <div class="ml-2 w-50">{{ p.card.brand }} - {{ p.card.lastFour }}</div>
          <div class="ml-2 w-50">{{ p.card.expMonth }} / {{ p.card.expYear }}</div>
          <div class="ml-auto">
            <b-button
             :disabled="p.isDefault"
              type="button"
              class="btn btn-outline-primary btn-sm collapsed"
              aria-expanded="false"
              aria-controls="collapse-job-filters"
              style="overflow-anchor: none"
              @click="defaultPayment(p)"
            >
              Default
            </b-button>
          </div>
          <b-button
            :disabled="p.isDefault"
            size="sm"
            variant="outline-danger"
            class="mx-2"
            @click="deleteClicked(p)"
            >X</b-button
          >
        </b-list-group-item>
        <hr />
        <div id="add-payment-card-ref">
          <!-- STRIPE ADD PAYMENT CARD GETS INJECTED HERE -->
        </div>
      </b-card-body>
      <b-card-footer class="d-flex justify-content-end">
        <b-button @click="addPayMethod">ADD</b-button>
      </b-card-footer>
    </b-card>
  </div>
</template>

<script>
import { getEnv, VUE_APP_STRIPE_ID } from '#/utils/env';

export default {
  data() {
    return {
      payMethods: [],
      deletedCardId: null,
    };
  },
  created() {
    this.getCardList();
  },
  mounted() {
    // TODO: reference as window.Stripe? whats best practice for scripts loaded just in time?
    this.resetCard();
  },
  methods: {
    resetCard() {
      this.stripe = Stripe(getEnv(VUE_APP_STRIPE_ID));
      const elements = this.stripe.elements();
      this.cardElement = elements.create('card');
      this.cardElement.mount('#add-payment-card-ref');
    },
    getCardList() {
      this.$store
        .dispatch('billing/retrieveSavedPaymentMethods')
        .then((payMethods) => {
          this.payMethods.length = 0;
          this.payMethods.push(...payMethods.paymentMethodsList);
        })
        .catch((error) => {
          console.error('received error from list payments', error);
        });
    },
    async addPayMethod() {
      this.$store
        .dispatch('billing/retrieveClientSecret')
        .then((clientSecretResponse) => {
          this.stripe
            .confirmCardSetup(clientSecretResponse.clientSecret, {
              payment_method: {
                card: this.cardElement,
                billing_details: {
                  // TODO: add actual billing details in
                  // name: 'MOCKED_NAME',
                },
              },
            })
            .then((setupIntent) => {
              this.resetCard();
              this.getCardList();
              if (setupIntent.status === 'succeeded') {
                // The setup has succeeded. Display a success message. Send
                // setupIntent.payment_method to your server to save the card to a Customer
              }
            })
            .catch((error) => {
              console.error('ERROR addPayMethod', error);
            });
        })
        .catch((error) => {
          console.error('ERROR getting client secret', error);
        });
    },
    deleteClicked(p) {
      this.deletedCardId = p;
      console.log('deleting ', p);
      const cardType = p.card.brand;
      const last4 = p.card.lastFour;
      const message = `Do you really want to remove the ${cardType} ending in ${last4}?`;
      this.$bvModal
        .msgBoxConfirm(message, {
          title: 'Remove Card',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'YES',
          cancelTitle: 'NO',
          headerClass: 'align-items-center',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
        })
        .then((userAcceptedRemoval) => {
          if (userAcceptedRemoval) {
            this.deletePayment(p);
          }
        })
        .catch((err) => {
          console.warn('error while removing card', err);
        });
    },
    async deletePayment(paymentMethod) {
      this.$store
        .dispatch('billing/deletePayment', { paymentId: paymentMethod.id })
        .then((deletePaymentResponse) => {
          this.getCardList();
        });
    },
    async defaultPayment(paymentMethod) {
      this.$store
        .dispatch('billing/setDefaultPaymentMethod', {
          paymentId: paymentMethod.id,
        })
        .then((defaultPaymentResponse) => {
          this.getCardList();
        });
    },
  },
};
</script>

<style scoped>
</style>
